export const dateFormat = 'DD/MM/YYYY';

type StatusColors = {
    [key: string]: string;
}

export const status_colors: StatusColors = {
    "RESTING": "#1BC5BD",
    "OTHER": "gray",
}

export const dynamicStatusColors = (status: string): string => {
    if(["riposo_obbligatorio", "riposo_regolare", "riposo_ridotto"].includes(status)){
        return status_colors["RESTING"];
    }
    return status_colors["OTHER"];
}
